export default "__VITE_ASSET__CWtjmkRR__"